import { Stack, Typography, TypographyProps } from "@mui/material";
import { isEmpty } from "lodash-es";
import { ReactNode } from "react";

import AppLink, { AppLinkProps } from "@/common/components/Link/AppLink";
import AppTypography from "@/common/components/Text/AppTypography";

export interface DetailedViewPageHeaderProps {
  image?: ReactNode;
  title: ReactNode;
  subtitle?: ReactNode;
  /** Action buttons to be placed on the left side. */
  startActions?: ReactNode;
  actions?: ReactNode;
  primaryActions?: ReactNode;
  secondaryActions?: ReactNode;
  closeAction?: ReactNode;
  titleProps?: {
    to?: string;
    linkProps?: Partial<AppLinkProps>;
    typographyProps?: Partial<TypographyProps>;
  };
  subtitleProps?: {
    to?: string;
    linkProps?: Partial<AppLinkProps>;
    typographyProps?: Partial<TypographyProps>;
  };
}

export default function DetailedViewPageHeader({
  image,
  title,
  subtitle,
  startActions,
  actions,
  primaryActions,
  secondaryActions,
  closeAction,
  titleProps,
  subtitleProps,
}: DetailedViewPageHeaderProps) {
  return (
    <Stack
      data-testid='DetailedViewPageHeader'
      direction='row'
      gap={1.5}
      sx={{
        // flex: 1,
        minWidth: 0,
        flexWrap: { xxs: "wrap", md: "nowrap" },
      }}
    >
      {startActions && (
        <Stack direction='row' gap={1} sx={{ alignItems: "center" }}>
          {startActions}
        </Stack>
      )}

      {image}

      {/* Title */}
      <Stack
        direction='column'
        gap={0.5}
        sx={{
          maxWidth: "100%",
          flex: 1,
        }}
      >
        <AppLink
          isEnabled={!isEmpty(titleProps?.to)}
          to={titleProps?.to || ""}
          {...titleProps?.linkProps}
        >
          <AppTypography
            variant='h1'
            {...titleProps?.typographyProps}
            sx={{
              minWidth: { xxs: 100, md: 0 },
              display: "flex",
              alignItems: "center",
              gap: 1,
              ...titleProps?.typographyProps?.sx,
            }}
            ellipsing={{ enabled: true, linesToStartEllipsing: 2 }}
          >
            {title}
          </AppTypography>
        </AppLink>

        {subtitle && (
          <AppLink
            isEnabled={!isEmpty(subtitleProps?.to)}
            to={subtitleProps?.to || ""}
            {...subtitleProps?.linkProps}
          >
            <Typography
              variant='subtitle1'
              color='text.secondary'
              {...subtitleProps?.typographyProps}
            >
              {subtitle}
            </Typography>
          </AppLink>
        )}
      </Stack>

      {/* Actions */}
      {(actions || primaryActions || secondaryActions || closeAction) && (
        <Stack direction='row' gap={1} sx={{ justifyContent: "flex-end", marginLeft: "auto" }}>
          <Stack direction='row' gap={1} sx={{ alignItems: "center" }}>
            {/* <Box>{primaryActions}</Box>
                {secondaryActions && <Box>{secondaryActions}</Box>} */}

            {primaryActions}
            {actions}
            {secondaryActions}
            {closeAction}
          </Stack>
        </Stack>
      )}
    </Stack>
  );
}
